import includes from "lodash/includes";
import lowerCase from "lodash/lowerCase";

/**
 * Filter array data by params attributes
 * can receive multiple attributes to filter
 */
export const filterData = <T>(
  array: Array<T>,
  params: { [key: string]: any }
): Array<T> => {
  if (!array) return [];

  Object.keys(params).map((key) => {
    array = array.filter((index) =>
      includes(lowerCase(index[key]), lowerCase(params[key]))
    );
  });

  return array;
};
